/**
 * Copy da vitrine do Otto (a chamada de vídeo da plataforma). Mostrada a quem ainda não tem o Otto dentro da Inbox.
 * Dados puros. Só descreve o que o Otto faz hoje: chamar por link, WhatsApp, Instagram ou Processo Já, sala de espera,
 * transcrição por pessoa, momentos marcados, busca e exportação. Gravação e análises NÃO aparecem: ainda não estão liberadas.
 * Nada de preço nem de nome de plano aqui: os planos do Otto ainda têm nomes provisórios (docs/specs/otto/PRICING.md).
 */
const ASSETS = '/assets';

export default {
    title: 'Otto',
    art: 'o Otto',
    plansTable: true,
    heroTitle: ['Chame o cliente por vídeo.', 'E a conversa vira texto.'],
    summary:
        'O Otto é a chamada de vídeo da plataforma. Você chama o cliente por link, pelo WhatsApp ou pelo aplicativo Processo Já, e a conversa é escrita enquanto acontece, com o nome de quem falou cada frase.',
    stripLabel: 'Chame por',
    strip: [
        { name: 'Link', logo: null },
        { name: 'WhatsApp', logo: `${ASSETS}/whatsapp_icon.svg` },
        { name: 'Instagram', logo: `${ASSETS}/Instagram_logo.svg` },
        { name: 'Processo Já', logo: `${ASSETS}/processo-ja.svg` },
    ],
    painTitle: 'A reunião acaba e ninguém lembra o que ficou combinado.',
    before: 'A Marina faz uma reunião com o Carlos por outro aplicativo. Quando termina, cada um guarda o que lembra, e depois ninguém acha o que foi dito.',
    after: 'A chamada acontece dentro da plataforma. O que cada pessoa disse fica escrito, com os momentos importantes marcados, e dá para buscar depois.',
    demoTitle: 'Veja uma chamada do Otto por dentro.',
    demoSub: 'Esta é a sala de verdade, com dados de exemplo. Escolha uma parte da tela e veja para que ela serve.',
    glossary: [
        { term: 'Otto', def: 'A chamada de vídeo da plataforma, com a conversa escrita.', logo: '/brand/otto/otto-icone.png' },
        { term: 'Sala de espera', def: 'Onde o cliente aguarda até você aprovar a entrada dele.', icon: 'users' },
        { term: 'Transcrição', def: 'A conversa escrita enquanto acontece, com quem falou cada frase.', icon: 'note' },
        { term: 'Momento', def: 'Uma marca na conversa para você achar o ponto depois.', icon: 'flag' },
    ],
    videoTitle: 'O Otto em uso.',
    poster: null,
    chapters: ['Chamar o cliente', 'Conduzir a reunião', 'Consultar depois'],
    exTitle: 'Veja as telas de verdade.',
    exSub: 'Escolha um recurso e veja a tela dele. O que está marcado "Em breve" ainda vai chegar.',
    groups: [
        { title: 'Chamar', items: ['Link para compartilhar', 'Pelo WhatsApp ou pelo Instagram da empresa', 'Pelo aplicativo Processo Já', 'A partir da conversa do cliente'] },
        { title: 'Conduzir', items: ['Sala de espera com aprovação', 'Compartilhar a tela', 'Janela flutuante enquanto você atende', 'Cliente entra pelo celular, no navegador'] },
        { title: 'Guardar', items: ['Transcrição por pessoa', 'Momentos marcados', 'Busca na transcrição', 'Exportar o texto'] },
    ],
    steps: [
        { title: 'Experimente', body: 'Libere o Otto e veja a tela com a sua equipe.' },
        { title: 'Chame o cliente', body: 'Gere o link e mande por onde o cliente preferir.' },
        { title: 'Converse', body: 'A transcrição aparece enquanto vocês falam e fica guardada no histórico.' },
    ],
    extraFaq: {
        q: 'O cliente precisa instalar algum aplicativo?',
        a: 'Para entrar pelo link, não: ele abre no navegador. Os clientes do aplicativo Processo Já também podem ser chamados por ele.',
    },
    finalTitle: 'Faça a reunião e fique com o registro.',
    finalBullets: [
        'Chamada por link, WhatsApp, Instagram ou Processo Já',
        'Transcrição por pessoa e momentos marcados',
        'Sala de espera, janela flutuante e contagem do fim',
    ],
};
